import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { BiTimeChart } from '@/features/dashboard-finance/charts/BiTimeChart';
import { formatPct, formatYyyymmddDisplay } from '@/features/dashboard-finance/formatters';

/** Churn diário (cancelamentos ÷ assinaturas ACTIVE atuais), em %. */
export function ChurnRateChart({
  series,
}: {
  series: readonly { yyyymmdd: string; pct: number }[];
}): React.JSX.Element {
  const { t } = useTranslation();
  const data = series.map((d) => ({ x: formatYyyymmddDisplay(d.yyyymmdd), y: d.pct }));
  return (
    <BiTimeChart
      title={t('sales.charts.churnRate')}
      subtitle={t('sales.charts.churnRateHint')}
      type="line"
      data={data}
      color="#dc2626"
      valueFormatter={(v): string => formatPct(v, 2)}
    />
  );
}
